const rawBaseUrl = import.meta.env.VITE_API_BASE_URL?.trim() || 'http://localhost:8000'

export const env = {
  apiBaseUrl: rawBaseUrl.replace(/\/$/, ''),
  requestTimeoutMs: 15_000,
} as const
